export const WEEK_DAYS = ["lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"] as const;
export type WeekDay = (typeof WEEK_DAYS)[number];

export const WEEK_DAY_LABELS: Record<WeekDay, string> = {
  lundi: "LUNDI",
  mardi: "MARDI",
  mercredi: "MERCREDI",
  jeudi: "JEUDI",
  vendredi: "VENDREDI",
  samedi: "SAMEDI",
};

export type ScheduleGridRow = {
  promotion: string;
  days: Record<WeekDay, string>;
};

export type ScheduleGridData = {
  weekLabel: string;
  facultyName?: string;
  rows: ScheduleGridRow[];
};

export type ScheduleDisplayMode = "grid" | "document";

export const GRID_MARKER = "__SCHEDULE_GRID__:";
